
<template>
  <div>
    <div class="row">
      <div class="col">
        <span class="float-right">
          <div class="search-bar input-group"  @click="searchModalVisible = true">
            <button class="btn btn-link" id="search-button" data-toggle="modal" data-target="#searchModal"><i class="tim-icons icon-zoom-split"></i>
              <span class="d-lg-none d-md-block">Search</span>
            </button>
          </div>
          <modal :show.sync="searchModalVisible"
                  class="modal-search"
                  id="searchModal"
                  :centered="false"
                  :show-close="true">
            <input type="text" id="ricerca" class="form-control" v-on:keyup="cerca()" name="ricerca" placeholder=" Cerca...">
          </modal>
        </span>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <card class="card">
          <h3>Pratiche utente {{username}}</h3>
          <div class="table-responsive">
            <div class="row justify-content-center" style="margin-bottom:40px">
              <div class="col-4">
                <div v-if="page != 1"><button v-on:click="changePage('indietro')" style="color:#00467f;padding: 0;border: none;background: none;"><i class="tim-icons icon-minimal-left" style="font-size:20px;color:#00467f"></i></button></div>
                <div v-else></div>
              </div>
              <div class="col-4">
                <p>Pagina <strong>{{page}}</strong> di <strong>{{totPage}}</strong></p>
              </div>
              <div class="col-4">
                <div v-if="page < totPage"><button v-on:click="changePage('avanti')" style="color:#00467f;padding: 0;border: none;background: none;"><i class="tim-icons icon-minimal-right" style="font-size:20px;color:#00467f"></i></button></div>
                <div v-else></div>
              </div>
            </div>
            <table class="table tablesorter" id="tabella" style="text-align: center">
              <thead>
                <tr>
                  <th @click="sort('DATA_INSERIMENTO')" style="text-decoration:underline">DATA</th>
                  <th @click="sort('AZIENDA')" style="text-decoration:underline">AZIENDA</th>
                  <th @click="sort('CODICE_FISCALE')" style="text-decoration:underline">CODICE FISCALE</th>
                  <th @click="sort('REFERENTE_AZIENDA')" style="text-decoration:underline">REFERENTE AZIENDA</th>
                  <th @click="sort('TEL')" style="text-decoration:underline">TEL</th>
                  <th @click="sort('MAIL')" style="text-decoration:underline">MAIL</th>
                  <th @click="sort('SEDE')" style="text-decoration:underline">SEDE DOVE EFFETTUARE IL SOPRALLUOGO</th>
                  <th @click="sort('TIPO')" style="text-decoration:underline">TIPO RICHIESTA</th>
                  <th @click="sort('AVANZAMENTO')" style="text-decoration:underline">AVANZAMENTO</th>
                  <th @click="sort('STATO')">STATO</th>
                  <th>UFFICIO</th>
                  <th>COGNOME NOME</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(valori) in sortedValori" v-bind:key="valori.ID"><!-- -->
                  <td>{{getDate(valori.DATA_INSERIMENTO)}}</td>
                  <td>{{valori.AZIENDA}}</td>
                  <td>{{valori.CF}}</td>
                  <td>{{valori.REFERENTE_AZIENDA}}</td>
                  <td>{{valori.TEL}}</td>
                  <td>{{valori.MAIL}}</td>
                  <td>{{valori.SEDE}}</td>
                  <td>{{valori.TIPO}}</td>
                  <td>{{valori.AVANZAMENTO}}</td>
                  <td><img :src="valori.IMMAGINE_CHECK" style="width:20px"></td>
                  <td v-if="valori.user.user_site != null">{{valori.user.user_site.UFFICIO}}</td>
                  <td v-else></td>
                  <td v-if="valori.user != null">{{valori.user.COGNOME}} {{valori.user.NOME}}</td>
                  <td v-else></td>
                <td><router-link :to="'/modifica-dati?id='+valori.ID"><i class="tim-icons icon-zoom-split" style="color:#00467f"></i></router-link></td>
                </tr>
              </tbody>
            </table>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import Card from "../components/Cards/Card.vue";
import Modal from "@/components/Modal.vue";
import Legenda from "@/components/Legenda.vue";
import PraticheServices from '@/services/PraticheServices';
import Services from '@/services/Services';

export default {
  components: {
    Card,
    Modal,
    Legenda
  },

  data() {
    return {
      id: null,
      username: null,
      searchModalVisible: false,
      searchQuery: '',
      page: 1,
      totPage: null,
      
      valoriConStato: [],
      allValoriConStato: [],
      img_check: [],
      avanzamento: null,
      status: null,
      token_response: '',
      valori: [],
      allPratiche: [],
      yellow_array: [],
      img_yellow: [],
      blue_array: [],
      img_blue: [],
      green_array: [],
      img_green: [],
      red_array: [],
      img_red: [],
      results: [],
      avanzamento_selected: null,
      filtra_per: null,
      user_livello: '',
      //per filtrare
      dateFrom: '',
      dateTo: '',
      filtroScelto: null,
      luogo: '',
      header:{
        headers: {
            'Content-type': 'application/json',
        }
      },
      currentSort:'DATA_INSERIMENTO',
      currentSortDir:'desc',
      urlRichieste: 'https://sviluppoallergeni.confcom.it/',//'https://apiintranet.confcom.it/'
    };
  },

    methods: {
      cerca: function() {
        let input, filter, table, tr, td, i, txtValue;
        input = document.getElementById("ricerca");
        filter = input.value.toUpperCase();
        table = document.getElementById("tabella");
        tr = table.getElementsByTagName("tr");
        let arrayFiltrato = [];
        for (i = 0; i < this.allvaloriConStato.length; i++) {
          txtValue = this.allvaloriConStato[i].AZIENDA;
          if (txtValue.toUpperCase().indexOf(filter) > -1) {
            arrayFiltrato.push(this.allvaloriConStato[i]);
          }
        }
        this.valoriConStato = arrayFiltrato;
        if (filter == "") {
          this.caricaPagina(this.id);
        }
      },

      refreshToken: async function() {
        let errore = 0;
        await Services.refreshToken()
        // await axios.post(
        //   this.urlRichieste + "token",
        //   {
        //     withCredentials: true,
        //     headers: {
        //         'Content-type': 'application/json',
        //     }
        //   }
        // )
        .then(response => { this.token_response = response.data})
        .catch(function (error) {
          // handle error
          if(error.response.status == 403 || error.response.status == 401){
            errore = error.response.status;
          }
        })
        if(errore == 403 || errore == 401){
          await this.logout();
          return false;
        }
        localStorage.setItem("access_token", this.token_response.accessToken);
        return true;
      },

      //OK
      caricaPallino: function(i){
        let stringaImmagine = "";
        if(this.allPratiche[i].CHECK_1 == false || this.allPratiche[i].CHECK_2 == false || this.allPratiche[i].CHECK_3 == false || this.allPratiche[i].CHECK_4 == false){
          this.red_array.push(this.allPratiche[i]);
          this.img_red.push(require("@/assets/img/red.png"));
          stringaImmagine = require("@/assets/img/red.png");
          return stringaImmagine;
        }
        else if( this.allPratiche[i].AVANZAMENTO == 1){
          //se ASCOM GIALLO
          if( localStorage.getItem("user_livello") == 2 || localStorage.getItem("user_livello") == 3){
            this.blue_array.push(this.allPratiche[i]);
            this.img_blue.push(require("@/assets/img/blue.png"));
            stringaImmagine = require("@/assets/img/blue.png");
            return stringaImmagine;
          }
          //Se SATEC BLU
          else if( localStorage.getItem("user_livello") ==  4 || localStorage.getItem("user_livello") == 5){
            this.blue_array.push(this.allPratiche[i]);
            this.img_blue.push(require("@/assets/img/blue.png"));
            stringaImmagine = require("@/assets/img/blue.png");
            return stringaImmagine;
          } else{
            //ADMIN 1 
            this.yellow_array.push(this.allPratiche[i]);
            this.img_yellow.push(require("@/assets/img/yellow.png"));
            stringaImmagine = require("@/assets/img/yellow.png");
            return stringaImmagine;
          }
        }
        else if( this.allPratiche[i].AVANZAMENTO == 2){
          //se ASCOM BLU
          if( localStorage.getItem('user_livello') == 2 || localStorage.getItem('user_livello') == 3){
            this.blue_array.push(this.allPratiche[i]);
            this.img_blue.push(require('@/assets/img/blue.png'));
            stringaImmagine = require('@/assets/img/blue.png');
            return stringaImmagine;
          }
          //Se SATEC GIALLO
          else if( localStorage.getItem('user_livello') ==  4 || localStorage.getItem('user_livello') == 5){
            this.img_yellow.push(require('@/assets/img/yellow.png'));
            this.yellow_array.push(this.allPratiche[i]);
            stringaImmagine = require('@/assets/img/yellow.png');
            return stringaImmagine;
          } else{
            //ADMIN 1 
            this.yellow_array.push(this.allPratiche[i]);
            this.img_yellow.push(require('@/assets/img/yellow.png'));
            stringaImmagine = require('@/assets/img/yellow.png');
            return stringaImmagine;
          }
        }
        else if( this.allPratiche[i].AVANZAMENTO == 3){
          //se ASCOM BLU
          if( localStorage.getItem('user_livello') == 2 || localStorage.getItem('user_livello') == 3 || localStorage.getItem('user_livello') == 5){
            this.blue_array.push(this.allPratiche[i]);
            this.img_blue.push(require('@/assets/img/blue.png'));
            stringaImmagine = require('@/assets/img/blue.png');
            return stringaImmagine;
          }
          //Se SATEC BLU
          else if( localStorage.getItem('user_livello') ==  4 ){
            this.yellow_array.push(this.allPratiche[i]);
            this.img_yellow.push(require('@/assets/img/yellow.png'));
            stringaImmagine = require('@/assets/img/yellow.png');
            return stringaImmagine;
          } else{
            //ADMIN 1 
            this.yellow_array.push(this.allPratiche[i]);
            this.img_yellow.push(require('@/assets/img/yellow.png'));
            stringaImmagine = require('@/assets/img/yellow.png');
            return stringaImmagine;
          }
        }
        else if( this.allPratiche[i].AVANZAMENTO == 4){
          //se ASCOM GIALLO
          if( localStorage.getItem('user_livello') == 2 || localStorage.getItem('user_livello') == 3){
            this.yellow_array.push(this.allPratiche[i]);
            this.img_yellow.push(require('@/assets/img/yellow.png'));
            stringaImmagine = require('@/assets/img/yellow.png');
            return stringaImmagine;
          }
          //Se SATEC BLU
          else if( localStorage.getItem('user_livello') ==  4|| localStorage.getItem('user_livello') == 5){
            this.blue_array.push(this.allPratiche[i]);
            this.img_blue.push(require('@/assets/img/blue.png'));
            stringaImmagine = require('@/assets/img/blue.png');
            return stringaImmagine;
          } else{
          //ADMIN 1 
            this.yellow_array.push(this.allPratiche[i]);
            this.img_yellow.push(require('@/assets/img/yellow.png'));
            stringaImmagine = require('@/assets/img/yellow.png');
            return stringaImmagine;
          }
        }
        else if( this.allPratiche[i].AVANZAMENTO == 5){
          //se ASCOM BLU
          if( localStorage.getItem('user_livello') == 2){
            this.yellow_array.push(this.allPratiche[i]);
            this.img_yellow.push(require('@/assets/img/yellow.png'));
            stringaImmagine = require('@/assets/img/yellow.png');
            return stringaImmagine;
          }
          //Se SATEC blue
          else if( localStorage.getItem( localStorage.getItem('user_livello') == 3 || 'user_livello') ==  4 || localStorage.getItem('user_livello') == 5){
            this.blue_array.push(this.allPratiche[i]);
            this.img_blue.push(require('@/assets/img/blue.png'));
            stringaImmagine = require('@/assets/img/blue.png');
            return stringaImmagine;
          } else{
            //ADMIN 1 
            this.blue_array.push(this.allPratiche[i]);
            this.img_blue.push(require('@/assets/img/blue.png'));
            stringaImmagine = require('@/assets/img/blue.png');
            return stringaImmagine;
          }
        }
        else if( this.allPratiche[i].AVANZAMENTO == 6){
          //se ASCOM BLU
          if( localStorage.getItem('user_livello') == 2 || localStorage.getItem('user_livello') == 3){
            this.blue_array.push(this.allPratiche[i]);
            this.img_blue.push(require('@/assets/img/blue.png'));
            stringaImmagine = require('@/assets/img/blue.png');
            return stringaImmagine;
          }
          //Se SATEC GIALLO
          else if( localStorage.getItem('user_livello') ==  4 || localStorage.getItem('user_livello') == 5){
            this.img_yellow.push(require('@/assets/img/yellow.png'));
            this.yellow_array.push(this.allPratiche[i]);
            stringaImmagine = require('@/assets/img/yellow.png');
            return stringaImmagine;
          } else{
            //ADMIN 1 
            this.img_yellow.push(require('@/assets/img/yellow.png'));
            this.yellow_array.push(this.allPratiche[i]);
            stringaImmagine = require('@/assets/img/yellow.png')
            return stringaImmagine;
          }
        }
        else if( this.allPratiche[i].AVANZAMENTO == 7){
          //se ASCOM BLU
          if (localStorage.getItem('user_livello') == 2 || localStorage.getItem('user_livello') == 3) {
            this.img_blue.push(require('@/assets/img/blue.png'));
            this.blue_array.push(this.allPratiche[i]);
            stringaImmagine = require('@/assets/img/blue.png');
            return stringaImmagine;
          }
          //Se SATEC BLUE
          else if( localStorage.getItem('user_livello') ==  4 || localStorage.getItem('user_livello') == 5){
            this.blue_array.push(this.allPratiche[i]);
            this.img_blue.push(require('@/assets/img/blue.png'));
            stringaImmagine = require('@/assets/img/blue.png');
            return stringaImmagine;
          } else{
            //ADMIN 1 
            this.img_yellow.push(require('@/assets/img/yellow.png'));
            this.yellow_array.push(this.allPratiche[i]);
            stringaImmagine = require('@/assets/img/yellow.png');
            return stringaImmagine;
          }
        }
        else if( this.allPratiche[i].AVANZAMENTO == 8){
          //se ASCOM BLU
          if( localStorage.getItem('user_livello') == 2 || localStorage.getItem('user_livello') == 3){
            this.blue_array.push(this.allPratiche[i]);
            this.img_blue.push(require('@/assets/img/blue.png'));
            stringaImmagine = require('@/assets/img/blue.png');
            return stringaImmagine;
          }
          //Se SATEC GIALLO
          else if( localStorage.getItem('user_livello') ==  4 || localStorage.getItem('user_livello') == 5){
            this.img_yellow.push(require('@/assets/img/yellow.png'));
            this.yellow_array.push(this.allPratiche[i]);
            stringaImmagine = require('@/assets/img/yellow.png');
            return stringaImmagine;
          } else{
            //ADMIN 1 
            this.yellow_array.push(this.allPratiche[i]);
            this.img_yellow.push(require('@/assets/img/yellow.png'));
            stringaImmagine = require('@/assets/img/yellow.png');
            return stringaImmagine;
          }
        }
        else if( this.allPratiche[i].AVANZAMENTO == 9){
          //se ASCOM VERDE
          if( localStorage.getItem('user_livello') == 2 || localStorage.getItem('user_livello') == 3){
            this.green_array.push(this.allPratiche[i]);
            this.img_green.push(require('@/assets/img/green.png'));
            stringaImmagine = require('@/assets/img/green.png');
            return stringaImmagine;
          }
          //Se SATEC VERDE
          else if( localStorage.getItem('user_livello') ==  4 || localStorage.getItem('user_livello') == 5){
            this.green_array.push(this.allPratiche[i]);
            this.img_green.push(require('@/assets/img/green.png'));
            stringaImmagine = require('@/assets/img/green.png');
            return stringaImmagine;
          } else{
            //ADMIN 1 
            this.green_array.push(this.allPratiche[i]);
            this.img_green.push(require('@/assets/img/green.png'));
            stringaImmagine = require('@/assets/img/green.png');
            return stringaImmagine;
          }
        } else{
          console.log("...");
          this.red_array.push(this.allPratiche[i]);
          this.img_red.push(require('@/assets/img/red.png'));
          stringaImmagine = require('@/assets/img/red.png');
          return stringaImmagine;
        }
      },

      caricaPalliniPagina: function(i){
        let stringStatus = '';
        if(this.valori[i].CHECK_1 == false || this.valori[i].CHECK_2 == false || this.valori[i].CHECK_3 == false || this.valori[i].CHECK_4 == false){
          this.img_check.push(require('@/assets/img/red.png'));
          stringStatus = require('@/assets/img/red.png');
          return stringStatus;
        }
        else if( this.valori[i].AVANZAMENTO == 1){
          //se ASCOM GIALLO
          if( localStorage.getItem('user_livello') == 2 || localStorage.getItem('user_livello') == 3){
            this.img_check.push(require('@/assets/img/blue.png'));
            stringStatus = require('@/assets/img/blue.png');
            return stringStatus;
          }
          //Se SATEC BLU
          else if( localStorage.getItem('user_livello') ==  4 || localStorage.getItem('user_livello') == 5){
            this.img_check.push(require('@/assets/img/blue.png'));
            stringStatus = require('@/assets/img/blue.png');
            return stringStatus;
          } else{
            //ADMIN 1 
            this.img_check.push(require('@/assets/img/yellow.png'));
            stringStatus = require('@/assets/img/yellow.png');
            return stringStatus;
          }
        }
        else if( this.valori[i].AVANZAMENTO == 2){
          //se ASCOM BLU
          if( localStorage.getItem('user_livello') == 2 || localStorage.getItem('user_livello') == 3){
            this.img_check.push(require('@/assets/img/blue.png'));
            stringStatus = require('@/assets/img/blue.png');
            return stringStatus;
          }
          //Se SATEC GIALLO
          else if( localStorage.getItem('user_livello') ==  4 || localStorage.getItem('user_livello') == 5){
            this.img_check.push(require('@/assets/img/yellow.png'));
            stringStatus = require('@/assets/img/yellow.png');
            return stringStatus;
          } else{
            //ADMIN 1 
            this.img_check.push(require('@/assets/img/yellow.png'));
            stringStatus = require('@/assets/img/yellow.png');
            return stringStatus;
          }
        }
        else if( this.valori[i].AVANZAMENTO == 3){
          //se ASCOM BLU
          if( localStorage.getItem('user_livello') == 2 || localStorage.getItem('user_livello') == 3 || localStorage.getItem('user_livello') == 5){
            this.img_check.push(require('@/assets/img/blue.png'));
            stringStatus = require('@/assets/img/blue.png');
            return stringStatus;
          }
          //Se SATEC BLU
          else if( localStorage.getItem('user_livello') ==  4 ){
            this.img_check.push(require('@/assets/img/yellow.png'));
            stringStatus = require('@/assets/img/yellow.png');
            return stringStatus;
          } else{
            //ADMIN 1 
            this.img_check.push(require('@/assets/img/yellow.png'));
            stringStatus = require('@/assets/img/yellow.png');
            return stringStatus;
          }
        }
        else if( this.valori[i].AVANZAMENTO == 4){
          //se ASCOM GIALLO
          if( localStorage.getItem('user_livello') == 2 || localStorage.getItem('user_livello') == 3){
            this.img_check.push(require('@/assets/img/yellow.png'));
            stringStatus = require('@/assets/img/yellow.png');
            return stringStatus;
          }
          //Se SATEC BLU
          else if( localStorage.getItem('user_livello') ==  4|| localStorage.getItem('user_livello') == 5){
            this.img_check.push(require('@/assets/img/blue.png'));
            stringStatus = require('@/assets/img/blue.png');
            return stringStatus;
          } else{
            //ADMIN 1 
            this.img_check.push(require('@/assets/img/yellow.png'));
            stringStatus = require('@/assets/img/yellow.png');
            return stringStatus;
          }
        }
        else if( this.valori[i].AVANZAMENTO == 5){
          //se ASCOM BLU
          if( localStorage.getItem('user_livello') == 2){
            this.img_check.push(require('@/assets/img/yellow.png'));
            stringStatus = require('@/assets/img/yellow.png');
            return stringStatus;
          }
          //Se SATEC blue
          else if( localStorage.getItem( localStorage.getItem('user_livello') == 3 || 'user_livello') ==  4 || localStorage.getItem('user_livello') == 5){
            this.img_check.push(require('@/assets/img/blue.png'));
            stringStatus = require('@/assets/img/blue.png');
            return stringStatus;
          } else{
            //ADMIN 1 
            this.img_check.push(require('@/assets/img/blue.png'));
            stringStatus = require('@/assets/img/blue.png');
            return stringStatus;
          }
        }
        else if( this.valori[i].AVANZAMENTO == 6){
          //se ASCOM BLU
          if( localStorage.getItem('user_livello') == 2 || localStorage.getItem('user_livello') == 3){
            this.img_check.push(require('@/assets/img/blue.png'));
            stringStatus = require('@/assets/img/blue.png');
            return stringStatus;
          }
          //Se SATEC GIALLO
          else if( localStorage.getItem('user_livello') ==  4 || localStorage.getItem('user_livello') == 5){
            this.img_check.push(require('@/assets/img/yellow.png'));
            stringStatus = require('@/assets/img/yellow.png');
            return stringStatus;
          } else{
            //ADMIN 1 
            this.img_check.push(require('@/assets/img/yellow.png'));
            stringStatus = require('@/assets/img/yellow.png');
            return stringStatus;
          }
        }
        else if( this.valori[i].AVANZAMENTO == 7){
          //se ASCOM BLU
          if( localStorage.getItem('user_livello') == 2 ||  localStorage.getItem('user_livello') == 3){
            this.img_check.push(require('@/assets/img/blue.png'));
            stringStatus = require('@/assets/img/blue.png');
            return stringStatus;
          }
          //Se SATEC BLUE
          else if(  localStorage.getItem('user_livello') ==  4 || localStorage.getItem('user_livello') == 5){
            this.img_check.push(require('@/assets/img/blue.png'));
            stringStatus = require('@/assets/img/blue.png');
            return stringStatus;
          } else{
            //ADMIN 1 
            this.img_check.push(require('@/assets/img/yellow.png'));
            stringStatus = require('@/assets/img/yellow.png');
            return stringStatus;
          }
        }
        else if( this.valori[i].AVANZAMENTO == 8){
          //se ASCOM BLU
          if( localStorage.getItem('user_livello') == 2 || localStorage.getItem('user_livello') == 3){
            this.img_check.push(require('@/assets/img/blue.png'));
            stringStatus = require('@/assets/img/blue.png');
            return stringStatus;
          }
          //Se SATEC GIALLO
          else if( localStorage.getItem('user_livello') ==  4 || localStorage.getItem('user_livello') == 5){
            this.img_check.push(require('@/assets/img/yellow.png'));
            stringStatus = require('@/assets/img/yellow.png');
            return stringStatus;
          } else{
            //ADMIN 1 
            this.img_check.push(require('@/assets/img/yellow.png'));
            stringStatus = require('@/assets/img/yellow.png');
            return stringStatus;
          }
        }
        else if( this.valori[i].AVANZAMENTO == 9){
          //se ASCOM VERDE
          if( localStorage.getItem('user_livello') == 2 || localStorage.getItem('user_livello') == 3){
            this.img_check.push(require('@/assets/img/green.png'));
            stringStatus = require('@/assets/img/green.png');
            return stringStatus;
          }
          //Se SATEC VERDE
          else if( localStorage.getItem('user_livello') ==  4 || localStorage.getItem('user_livello') == 5){
            this.img_check.push(require('@/assets/img/green.png'));
            stringStatus = require('@/assets/img/green.png');
            return stringStatus;
          } else{
            //ADMIN 1 
            this.img_check.push(require('@/assets/img/green.png'));
            stringStatus = require('@/assets/img/green.png');
            return stringStatus;
          }
        } else{
          console.log("stato avanzamento sbagliato");
          this.img_check.push(require('@/assets/img/red.png'));
          stringStatus = require('@/assets/img/red.png');
          return stringStatus;
        }
      },

      changePage: async function(val){
        let user_id = localStorage.getItem('user_id');
        let risposta;
        let errore = 0;
        if(val == 'avanti'){
          this.page = this.page + 1;
        } else {
          //indietro
          this.page = this.page - 1;
        }
        this.img_check = [];
        const token = localStorage.getItem('access_token');
        //se ascom ognuno vede le sue 
        await PraticheServices.changePageUtente(this.page, user_id)
        // await axios.get(
        //   this.urlRichieste + 'pratica?page=' + this.page + '&limit=10&CREATA_DA=' + user_id,
        //   //'https://sviluppoallergeni.confcom.it/pratica?page='+this.page+'&limit=10&CREATA_DA='+user_id, 
        //   {
        //     headers: {
        //     'Content-type': 'application/json',
        //     'Authorization': `Bearer ${token}`
        //     }
        // })
        .then(response => { risposta = response.data})
        .catch( async function (error) {
        // handle error
          if(error.response.status == 401){
            errore = error.response.status;
          }
        })
        if (errore == 401) {
          let value = await this.refreshToken();
          if (value) { await this.changePage(); }
        }
        this.valori = risposta.rows;
        this.valoriConStato = [];
        let array = [];
        for (let i = 0; i < this.valori.length; i++) {
          if (this.valori[i].CHECK_1 == false || this.valori[i].CHECK_2 == false || this.valori[i].CHECK_3 == false || this.valori[i].CHECK_4 == false) {
            this.img_check.push(require('@/assets/img/red.png'));
            array = {ATTIVITA_CONFERMATE: this.valori[i].ATTIVITA_CONFERMATE, AVANZAMENTO: this.valori[i].AVANZAMENTO, AZIENDA: this.valori[i].AZIENDA, CF: this.valori[i].CF , 
            CHECK_1: this.valori[i].CHECK_1, CHECK_2: this.valori[i].CHECK_2, CHECK_3: this.valori[i].CHECK_3, CHECK_4: this.valori[i].CHECK_4, CREATA_DA: this.valori[i].CREATA_DA, 
            DATA_ACC_PREVENTIVO: this.valori[i].DATA_ACC_PREVENTIVO, DATA_CHIUSURA: this.valori[i].DATA_CHIUSURA, DATA_INSERIMENTO: this.valori[i].DATA_INSERIMENTO, DATA_INVIO_PREVENTIVO: this.valori[i].DATA_INVIO_PREVENTIVO, 
            DATA_SOPRALLUOGO: this.valori[i].DATA_SOPRALLUOGO, ID: this.valori[i].ID, IMPORTO_FATTURARE: this.valori[i].IMPORTO_FATTURARE, MAIL: this.valori[i].MAIL, PAGATO: this.valori[i].PAGATO, 
            PREZZO_CONSIGLIATO: this.valori[i].PREZZO_CONSIGLIATO, PREZZO_SATEC: this.valori[i].PREZZO_SATEC, REFERENTE_AZIENDA: this.valori[i].REFERENTE_AZIENDA, RIF_FT: this.valori[i].RIF_FT, SEDE: this.valori[i].SEDE, 
            TECNICO_SOPRALLUOGO: this.valori[i].TECNICO_SOPRALLUOGO, TECNICO_SVOLGIMENTO: this.valori[i].TECNICO_SVOLGIMENTO, TEL: this.valori[i].TEL, TIPO: this.valori[i].TIPO, IMMAGINE_CHECK: require('@/assets/img/red.png')}
            this.valoriConStato.push(array);
          } else {
            let immagine = this.caricaPalliniPagina(i);
            array = {ATTIVITA_CONFERMATE: this.valori[i].ATTIVITA_CONFERMATE, AVANZAMENTO: this.valori[i].AVANZAMENTO, AZIENDA: this.valori[i].AZIENDA, CF: this.valori[i].CF , 
            CHECK_1: this.valori[i].CHECK_1, CHECK_2: this.valori[i].CHECK_2, CHECK_3: this.valori[i].CHECK_3, CHECK_4: this.valori[i].CHECK_4, CREATA_DA: this.valori[i].CREATA_DA, 
            DATA_ACC_PREVENTIVO: this.valori[i].DATA_ACC_PREVENTIVO, DATA_CHIUSURA: this.valori[i].DATA_CHIUSURA, DATA_INSERIMENTO: this.valori[i].DATA_INSERIMENTO, DATA_INVIO_PREVENTIVO: this.valori[i].DATA_INVIO_PREVENTIVO, 
            DATA_SOPRALLUOGO: this.valori[i].DATA_SOPRALLUOGO, ID: this.valori[i].ID, IMPORTO_FATTURARE: this.valori[i].IMPORTO_FATTURARE, MAIL: this.valori[i].MAIL, PAGATO: this.valori[i].PAGATO, 
            PREZZO_CONSIGLIATO: this.valori[i].PREZZO_CONSIGLIATO, PREZZO_SATEC: this.valori[i].PREZZO_SATEC, REFERENTE_AZIENDA: this.valori[i].REFERENTE_AZIENDA, RIF_FT: this.valori[i].RIF_FT, SEDE: this.valori[i].SEDE, 
            TECNICO_SOPRALLUOGO: this.valori[i].TECNICO_SOPRALLUOGO, TECNICO_SVOLGIMENTO: this.valori[i].TECNICO_SVOLGIMENTO, TEL: this.valori[i].TEL, TIPO: this.valori[i].TIPO, IMMAGINE_CHECK: immagine}
            this.valoriConStato.push(array);
          }
        }
      },

      caricaPagina: async function(user_id){
        const token = localStorage.getItem('access_token');
        //let user_id = localStorage.getItem('user_id');
        let isLogged = localStorage.getItem('isLogged');
        let risposta;
        this.img_check = [];
        let errore = 0;
        // vede solo ascom
        await PraticheServices.get10PraticheUtente(user_id)
        // await axios.get(
        //   this.urlRichieste + 'pratica?filter=true&page=1&limit=10&CREATA_DA=' +  user_id,
        //   //'https://sviluppoallergeni.confcom.it/pratica?filter=true&page=1&limit=10&CREATA_DA=' + user_id, 
        //   {
        //     headers: {
        //       'Content-type': 'application/json',
        //       'Authorization': `Bearer ${token}`
        //     }
        //   }
        // )
        .then(response => { risposta = response.data})
        .catch( async function (error) {
        // handle error
          if(error.response.status == 401){
              errore = error.response.status;
          }
        });
        if (errore == 401 && isLogged == true){
          let value = await this.refreshToken();
          if (value) { await this.caricaPagina(this.id); }
        } else if (errore == 401) { // && isLogged == false
          this.logout();
          this.$router.push({
              path: "/login"
          });
        }
        this.valori = risposta.rows;
        this.valoriConStato = [];
        // Faciamo che ne mostro 10 per pagina
        let total = this.allPratiche.length;
        this.totPage = Math.ceil(total/10);
        let array = [];
        for (let i = 0; i < this.valori.length; i++) {
          if (this.valori[i].CHECK_1 == false || this.valori[i].CHECK_2 == false || this.valori[i].CHECK_3 == false || this.valori[i].CHECK_4 == false || this.valori[i].AVANZAMENTO > 9) {
            this.img_check.push(require('@/assets/img/red.png'));
            array = {ATTIVITA_CONFERMATE: this.valori[i].ATTIVITA_CONFERMATE, AVANZAMENTO: this.valori[i].AVANZAMENTO, AZIENDA: this.valori[i].AZIENDA, CF: this.valori[i].CF , 
            CHECK_1: this.valori[i].CHECK_1, CHECK_2: this.valori[i].CHECK_2, CHECK_3: this.valori[i].CHECK_3, CHECK_4: this.valori[i].CHECK_4, CREATA_DA: this.valori[i].CREATA_DA, 
            DATA_ACC_PREVENTIVO: this.valori[i].DATA_ACC_PREVENTIVO, DATA_CHIUSURA: this.valori[i].DATA_CHIUSURA, DATA_INSERIMENTO: this.valori[i].DATA_INSERIMENTO, DATA_INVIO_PREVENTIVO: this.valori[i].DATA_INVIO_PREVENTIVO, 
            DATA_SOPRALLUOGO: this.valori[i].DATA_SOPRALLUOGO, ID: this.valori[i].ID, IMPORTO_FATTURARE: this.valori[i].IMPORTO_FATTURARE, MAIL: this.valori[i].MAIL, PAGATO: this.valori[i].PAGATO, 
            PREZZO_CONSIGLIATO: this.valori[i].PREZZO_CONSIGLIATO, PREZZO_SATEC: this.valori[i].PREZZO_SATEC, REFERENTE_AZIENDA: this.valori[i].REFERENTE_AZIENDA, RIF_FT: this.valori[i].RIF_FT, SEDE: this.valori[i].SEDE, 
            TECNICO_SOPRALLUOGO: this.valori[i].TECNICO_SOPRALLUOGO, TECNICO_SVOLGIMENTO: this.valori[i].TECNICO_SVOLGIMENTO, TEL: this.valori[i].TEL, TIPO: this.valori[i].TIPO, IMMAGINE_CHECK: require('@/assets/img/red.png')}
            this.valoriConStato.push(array);
          } else {
            let immagine = this.caricaPalliniPagina(i);
            array = {ATTIVITA_CONFERMATE: this.valori[i].ATTIVITA_CONFERMATE, AVANZAMENTO: this.valori[i].AVANZAMENTO, AZIENDA: this.valori[i].AZIENDA, CF: this.valori[i].CF , 
            CHECK_1: this.valori[i].CHECK_1, CHECK_2: this.valori[i].CHECK_2, CHECK_3: this.valori[i].CHECK_3, CHECK_4: this.valori[i].CHECK_4, CREATA_DA: this.valori[i].CREATA_DA, 
            DATA_ACC_PREVENTIVO: this.valori[i].DATA_ACC_PREVENTIVO, DATA_CHIUSURA: this.valori[i].DATA_CHIUSURA, DATA_INSERIMENTO: this.valori[i].DATA_INSERIMENTO, DATA_INVIO_PREVENTIVO: this.valori[i].DATA_INVIO_PREVENTIVO, 
            DATA_SOPRALLUOGO: this.valori[i].DATA_SOPRALLUOGO, ID: this.valori[i].ID, IMPORTO_FATTURARE: this.valori[i].IMPORTO_FATTURARE, MAIL: this.valori[i].MAIL, PAGATO: this.valori[i].PAGATO, 
            PREZZO_CONSIGLIATO: this.valori[i].PREZZO_CONSIGLIATO, PREZZO_SATEC: this.valori[i].PREZZO_SATEC, REFERENTE_AZIENDA: this.valori[i].REFERENTE_AZIENDA, RIF_FT: this.valori[i].RIF_FT, SEDE: this.valori[i].SEDE, 
            TECNICO_SOPRALLUOGO: this.valori[i].TECNICO_SOPRALLUOGO, TECNICO_SVOLGIMENTO: this.valori[i].TECNICO_SVOLGIMENTO, TEL: this.valori[i].TEL, TIPO: this.valori[i].TIPO, IMMAGINE_CHECK: immagine}
            this.valoriConStato.push(array);
          }
        }
      },

      getAllPratiche: async function(user_id){
        const token = localStorage.getItem('access_token');
        //let user_id = localStorage.getItem('user_id');
        let isLogged = localStorage.getItem('isLogged');
        let errore = 0;
        //se ascom vede solo le sue
        await PraticheServices.getPraticheUtente(user_id)
        // await axios.get(
        //   this.urlRichieste + 'pratica?filter=true&CREATA_DA=' + user_id,
        //   //'https://sviluppoallergeni.confcom.it/pratica?filter=true&CREATA_DA=' + user_id, 
        //   {
        //     headers: {
        //       'Content-type': 'application/json',
        //       'Authorization': `Bearer ${token}`
        //     }
        //   }
        // )
        .then(response => { this.allPratiche = response.data})
        .catch( async function (error) {
          // handle error
          if(error.response.status == 401){
            errore = error.response.status;
          }
        });
        if (errore == 401 && isLogged == true){
          let value = await this.refreshToken();
          if (value) { await this.getAllPratiche(this.id); }
        } else if (errore == 401 && isLogged == false) {
          this.logout();
          this.$router.push({
              path: '/login'
          });
        }
        this.allvaloriConStato = [];
        for(let i = 0; i < this.allPratiche.length; i++){
          let immagine = this.caricaPallino(i);
          let array = {ATTIVITA_CONFERMATE: this.allPratiche[i].ATTIVITA_CONFERMATE, AVANZAMENTO: this.allPratiche[i].AVANZAMENTO, AZIENDA: this.allPratiche[i].AZIENDA, CF: this.allPratiche[i].CF , 
          CHECK_1: this.allPratiche[i].CHECK_1, CHECK_2: this.allPratiche[i].CHECK_2, CHECK_3: this.allPratiche[i].CHECK_3, CHECK_4: this.allPratiche[i].CHECK_4, CREATA_DA: this.allPratiche[i].CREATA_DA, 
          DATA_ACC_PREVENTIVO: this.allPratiche[i].DATA_ACC_PREVENTIVO, DATA_CHIUSURA: this.allPratiche[i].DATA_CHIUSURA, DATA_INSERIMENTO: this.allPratiche[i].DATA_INSERIMENTO, DATA_INVIO_PREVENTIVO: this.allPratiche[i].DATA_INVIO_PREVENTIVO, 
          DATA_SOPRALLUOGO: this.allPratiche[i].DATA_SOPRALLUOGO, ID: this.allPratiche[i].ID, IMPORTO_FATTURARE: this.allPratiche[i].IMPORTO_FATTURARE, MAIL: this.allPratiche[i].MAIL, PAGATO: this.allPratiche[i].PAGATO, 
          PREZZO_CONSIGLIATO: this.allPratiche[i].PREZZO_CONSIGLIATO, PREZZO_SATEC: this.allPratiche[i].PREZZO_SATEC, REFERENTE_AZIENDA: this.allPratiche[i].REFERENTE_AZIENDA, RIF_FT: this.allPratiche[i].RIF_FT, SEDE: this.allPratiche[i].SEDE, 
          TECNICO_SOPRALLUOGO: this.allPratiche[i].TECNICO_SOPRALLUOGO, TECNICO_SVOLGIMENTO: this.allPratiche[i].TECNICO_SVOLGIMENTO, TEL: this.allPratiche[i].TEL, TIPO: this.allPratiche[i].TIPO, IMMAGINE_CHECK: immagine}
          this.allvaloriConStato.push(array);
        }
      },

      logout: async function () {
        let token = localStorage.getItem('access_token');
        await Services.logout()
        // await axios.delete(
        //   this.urlRichieste + 'logout',
        //   //'https://sviluppoallergeni.confcom.it/logout',
        //   {
        //     withCredentials: true,
        //     headers: {
        //       'Content-type': 'application/json',
        //       //'Authorization': `Bearer ${token}`
        //     }
        // }
        // )
        .then(response => { this.results = response.data})
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        localStorage.setItem('isLogged', false);
        localStorage.removeItem('user_nome');
        localStorage.removeItem('user_cognome');
        localStorage.removeItem('user_tipologia');
        localStorage.removeItem('user_email');
        localStorage.removeItem('user_livello');
        localStorage.removeItem('user_id');
        this.$router.push({
            path: '/login'
        });
      },

      sort:function(s) {
        if (s === this.currentSort) {
          this.currentSortDir = this.currentSortDir==='asc'?'desc':'asc';
        }
        this.currentSort = s;
      },

      main: async function() {
        this.id = this.$route.query.id
        this.username = this.$route.query.username
        axios.defaults.withCredentials = true;
        this.user_livello = localStorage.getItem('user_livello');
        try {
          await this.getAllPratiche(this.id);
          await this.caricaPagina(this.id);
        } catch (error) {
          if (error.response.status == 401) {
            await this.refreshToken();
          }
        }
      },

      getDate(datetime) {
        return moment(String(datetime)).format('DD-MM-YYYY');
      }
    },

    mounted() {
        this.main();
    },

    computed:{
      sortedValori:function() {
        return this.valoriConStato.sort((a,b) => {
          let modifier = 1;
          if(this.currentSortDir === 'desc') modifier = -1;
          if(a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
          if(a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
          return 0;
        });
      },
    },

    beforeMount: function(){},
};
</script>
<style scoped>
.arrow {
  border: solid #00467f;
  border-width: 0 3px 3px 0;
  background: white;
  display: inline-block;
  padding: 7px;
}

.right {
  transform: rotate(-45deg);
}

.left {
  transform: rotate(135deg);
}

@media screen and (max-width: 500px) {
  .hidemobile {
    display: none;
  }
}
@media screen and (min-width: 500px) {
  .hidecomputer {
    display:  none;
  }
}

body {
  font-family: Roboto,sans-serif;
}
button, input, optgroup, select, textarea {
    font-family: Roboto,sans-serif;
}
</style>
